module.exports = __webpack_public_path__ + "static/TenguEagleA-a51a09e6a94a0e84748cf1e059f81782.gif";